module.exports = __webpack_public_path__ + "img/pre.db9a3d7a.svg";